/**
 * Imprime a consulta — ou salva em PDF pela janela de impressão.
 *
 * Copia o HTML já desenhado das fichas em vez de montar outro: a versão em papel
 * que diverge do prontuário na tela é pior que nenhuma.
 */

import { abrirImpressao, escaparHtml } from '@/comuns/impressao';

export interface CabecalhoDaImpressao {
    paciente: string;
    linhas: string[];
    alergias?: string;
}

/** `false` quando o navegador bloqueou a janela — quem chama avisa. */
export function imprimirConsulta(cabecalho: CabecalhoDaImpressao, conteudo: HTMLElement | null): boolean {
    return abrirImpressao({
        titulo: `${cabecalho.paciente} · consulta`,
        estilo: 'h1{font-family:var(--font-display);font-size:20px;margin:0 0 4px;letter-spacing:-.02em}'
            + 'p.sub{margin:0 0 4px;font-size:12px;color:var(--text-secondary)}'
            + 'p.alerta{margin:12px 0 16px;padding:8px 10px;border:1px solid var(--border-strong);border-radius:8px;font-size:12px}'
            + 'section{break-inside:avoid;margin-bottom:14px}',
        corpo: `<h1>${escaparHtml(cabecalho.paciente)}</h1>`
            + cabecalho.linhas.map((l) => `<p class="sub">${escaparHtml(l)}</p>`).join('')
            + (cabecalho.alergias ? `<p class="alerta"><strong>Alergias:</strong> ${escaparHtml(cabecalho.alergias)}</p>` : '')
            + (conteudo?.innerHTML ?? '<p class="sub">Nenhuma ficha nesta consulta.</p>'),
    });
}
